<template>
  <el-form :model="{}" @submit.native.prevent label-width="180px">
    <template v-if="planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH">
      <el-form-item label="计划形式">
        <el-radio-group v-model="planForm.automatic_site_enabled">
          <el-radio-button ghost :label="false"> 手动版位 </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="版位选择" prop="siteSet">
        <el-checkbox-group v-model="planForm.siteSet">
          <el-checkbox-button ghost v-for="siteSet in SEARCH_AD_SITE_SET_LIST" :label="siteSet.label" :key="siteSet.label">
            {{ siteSet.name }}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="QQ浏览器等流量场景" v-if="planForm.siteSet.includes(SEARCH_AD_SITE_ENUM.QBSEARCH)">
        <el-radio-group v-model="planForm.qbsearch_scene">
          <el-radio-button ghost :label="0">不限</el-radio-button>
          <el-radio-button ghost :label="1">自定义</el-radio-button>
        </el-radio-group>
        <div v-if="planForm.qbsearch_scene === 1">
          <el-checkbox-group v-model="planForm.qbSearchScene">
            <el-checkbox :label="p.value" v-for="p in qbSearchScenes" :key="p.value">{{ p.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <el-form-item label="微信搜一搜流量场景" v-if="planForm.siteSet.includes(SEARCH_AD_SITE_ENUM.WECHAT_SEARCH)">
        <el-radio-group v-model="planForm.wechat_search_scene">
          <el-radio-button ghost :label="0">不限</el-radio-button>
          <el-radio-button ghost :label="1">自定义</el-radio-button>
        </el-radio-group>

        <div v-if="planForm.wechat_search_scene === 1">
          <el-checkbox-group v-model="planForm.wechatSearchScene">
            <el-checkbox :label="p.value" v-for="p in wechatSearchScenes" :key="p.value">{{ p.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <!-- <el-form-item label="关键词">
         <el-button :disabled="!planForm.account.id" @click="onSearchKeywordAdd">+添加关键词</el-button>
        <span>&emsp;已选{{ planForm.searchAdBidKeywords.length }}/1000</span>
      </el-form-item> -->
    </template>

    <template v-else>
      <el-form-item label="计划形式">
        <el-radio-group
          :disabled="pageStates.isEdit || pageStates.isDuplicate"
          v-model="planForm.automatic_site_enabled"
          @change="onSiteSetTypeChange"
        >
          <el-radio-button ghost :label="false">手动版位</el-radio-button>
          <el-radio-button ghost :label="true">自动版位</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <template v-if="planForm.automatic_site_enabled">
        <el-form-item label="探索策略">
          <el-radio-group v-model="planForm.exploration_strategy">
            <el-radio-button ghost :label="EXPLORATION_ENUM.AUTOMATIC">自动探索</el-radio-button>
            <el-radio-button
              ghost
              :label="EXPLORATION_ENUM.STEADY"
              :disabled="planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART"
            >
              稳步探索
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="优选版位" prop="priority_site_set" v-if="planForm.exploration_strategy === EXPLORATION_ENUM.STEADY">
          <el-checkbox-group v-model="planForm.priority_site_set">
            <el-checkbox-button ghost v-for="siteSet in SITE_SET_LIST" :label="siteSet.label" :key="siteSet.label">
              {{ siteSet.name }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </template>

      <el-form-item label="版位选择" v-if="!planForm.automatic_site_enabled">
        <el-checkbox-group :disabled="pageStates.isEdit" v-model="planForm.siteSet" @change="onSiteSetItemChange">
          <el-checkbox-button ghost v-for="siteSet in SITE_SET_LIST" :label="siteSet.label" :key="siteSet.label">
            {{ siteSet.name }}
          </el-checkbox-button>
        </el-checkbox-group>
        <p style="font-size: 12px" v-if="planForm.siteSet.includes(SITE_ENUM.PCQQ)">【腾讯电脑端】流量当前仅用于“微信小游戏”投放</p>
      </el-form-item>
    </template>

    <template v-if="planForm.siteSet.includes(SITE_ENUM.PCQQ)">
      <el-form-item label="腾讯电脑端定投">
        <el-radio-group v-model="planForm.pc_scene">
          <el-radio-button ghost :label="0">不限</el-radio-button>
          <el-radio-button ghost :label="1">自定义</el-radio-button>
        </el-radio-group>

        <div v-if="planForm.pc_scene === 1">
          <el-checkbox-group v-model="planForm.pcScene">
            <el-checkbox :label="p.value" v-for="p in pcScenes" :key="p.value">{{ p.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </template>

    <!-- 手动版位包含微信视频号 、自动版位显示 -->
    <template v-if="planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_3">
      <template v-if="showWechatChannels">
        <el-form-item label="微信视频号定投">
          <el-radio-group v-model="planForm.wechat_channels">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div class="wechat-scene-spec" v-if="planForm.wechat_channels === 1">
            <el-checkbox-group v-model="planForm.wechatChannels">
              <el-checkbox :label="p.id" v-for="p in wechatChannelPositions" :key="p.id">{{ p.description }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
      </template>
      <!-- 只有手动版位包含微信公众号与小程序才显示 -->
      <!-- 20240319 增加自动版位显示 -->
      <template v-if="planForm.siteSet.includes(SITE_ENUM.WECHAT) || planForm.automatic_site_enabled">
        <el-form-item label="微信公众号与小程序定投">
          <el-radio-group v-model="planForm.wechat_position" :disabled="pageStates.isEdit || pageStates.isDuplicate">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div class="wechat-scene-spec wechat-positions-checkbox" v-if="planForm.wechat_position === 1">
            <el-checkbox-group :disabled="pageStates.isEdit || pageStates.isDuplicate" v-model="planForm.wechatPostion">
              <el-checkbox :label="p.id" v-for="p in wechatPositions" :key="p.id">{{ p.description }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>

        <el-form-item label="微信公众号与小程序场景">
          <el-radio-group v-model="planForm.wechat_scene">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div class="wechat-scene-spec wechat-scenes-checkbox" v-if="planForm.wechat_scene === 1">
            <div class="wechat-scenes-row official-account-cate">
              <div class="title">公众号媒体类型</div>
              <el-checkbox-group v-model="planForm.officialAccountMediaCate" @change="onOfficialAccountMediaCateChange">
                <el-checkbox :label="p.id" v-for="p in officialAccountMediaCates" :key="p.id">{{ p.description }}</el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="wechat-scenes-row mini-game">
              <div class="title">
                <span>小程序小游戏流量类型</span>
                <el-popover
                  placement="top-start"
                  width="190"
                  trigger="hover"
                  content="场景对应定投投放位：小程序banner、小程序激励式、小程序插屏、小程序封面"
                >
                  <span class="el-icon-info" slot="reference"></span>
                </el-popover>
                <span v-show="showMiniGameTips" style="color: orange">&ensp;你未选择该流量场景对应定投的投放位，设置将不会生效</span>
              </div>
              <el-checkbox-group v-model="planForm.miniGame" @change="onMiniGameChange">
                <el-checkbox :label="p.id" v-for="p in miniGames" :key="p.id">{{ p.description }}</el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="wechat-scenes-row pay-scene">
              <div class="title">
                <span>订单详情页消费场景</span>
                <el-popover placement="top-start" width="190" trigger="hover" content="场景对应定投投放位：微信支付订单详情页">
                  <span class="el-icon-info" slot="reference"></span>
                </el-popover>

                <span v-show="showPaySceneTips" style="color: orange">&ensp;你未选择该流量场景对应定投的投放位，设置将不会生效</span>
              </div>
              <el-checkbox-group v-model="planForm.payScene" @change="onPaySceneChange">
                <el-checkbox :label="p.id" v-for="p in payScenes" :key="p.id">{{ p.description }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>
      </template>

      <template v-if="planForm.siteSet.includes(SITE_ENUM.MOBILE_UNION)">
        <el-form-item label="优量汇展示场景">
          <el-radio-group v-model="planForm.displaySceneType">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div style="margin-top: 6px" v-if="planForm.displaySceneType === 1">
            <el-checkbox-group v-model="planForm.scene_spec.display_scene">
              <el-checkbox-button ghost label="DISPLAY_SCENE_BANNER">Banner</el-checkbox-button>
              <el-checkbox-button ghost label="DISPLAY_SCENE_INLINE">插屏</el-checkbox-button>
              <el-checkbox-button ghost label="DISPLAY_SCENE_SPLASH">开屏</el-checkbox-button>
              <el-checkbox-button ghost label="DISPLAY_SCENE_NATIVE">原生</el-checkbox-button>
              <el-checkbox-button ghost label="DISPLAY_SCENE_REWARDED_VIDEO">激励视频</el-checkbox-button>
            </el-checkbox-group>
          </div>
        </el-form-item>

        <el-form-item label="优量汇自动流量优选">
          <el-switch v-model="planForm.flow_optimization_enabled"></el-switch>
        </el-form-item>

        <el-form-item label="优量汇流量包屏蔽" prop="exclude_union_position">
          <el-radio-group v-model="planForm.excludeUnionType" @change="onExcludeUnionPackageTypeChange">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div v-if="adAccounts.length">
            <div
              class="exclude-union-selector"
              v-loading="excludePackageLoading"
              style="margin-top: 6px"
              v-if="planForm.excludeUnionType === 1"
            >
              <div class="accounts">
                <div class="header">账号</div>

                <div class="row-list">
                  <div
                    class="row-item"
                    :class="{ active: ac.id === currUnionPackageAccountId }"
                    v-for="ac in adAccounts"
                    :key="ac.id"
                    @click="onAccountItemChange(ac)"
                  >
                    <span>{{ ac.name }}</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>

              <CascaderSelector
                v-model="excludesUnionPositionPackages"
                filterable
                :props="{ multiple: true, value: 'id', label: 'value' }"
                :max="5"
                :options="unionPositionPackages"
              />
            </div>
          </div>
          <div v-else>请先选择账号</div>
        </el-form-item>
      </template>
    </template>
  </el-form>
</template>
<script>
// import CascaderSelector from '@/components/cascader-select/index.vue'
import CascaderSelector from '@/components/cascader-select/index.vue'
import { getWechatPositions, getUnionPositionPackages } from '@/api/tencent.model'
import { isArray } from '@/common/js/utils.js'
import SITESET_CONST, {
  SITE_ENUM,
  DEFAULT_SITES,
  SITESET_PCQQ_SCENES,
  SEARCH_AD_SITE_ENUM,
  SITESET_QBSEARCH_SCENES,
  SITESET_WECHAT_SEARCH_SCENES,
  SEARCH_AD_SITE_SET_LIST
} from '@/views/create/gdt/model/siteset/siteset-const.js'
import { V3_MANUAL_SITES } from '@/views/create/gdt/model/project-form.js'
import { AD_MARKETING_SCENE } from '@/views/create/gdt/model/project-const.js'
const getAllSiteSet = () => SITESET_CONST.SITE_SET_LIST.map((s) => s.label)

export default {
  components: { CascaderSelector },
  props: {
    value: {
      type: Object
    }
  },
  inject: ['projectInstance'],
  data() {
    return {
      ...SITESET_CONST,
      SITE_ENUM,
      SEARCH_AD_SITE_SET_LIST,
      currUnionPackageAccountId: 0,
      excludePackageLoading: false,
      wechatPositions: [],
      wechatChannelPositions: [],
      officialAccountMediaCates: [],
      unionPositionPackages: [],
      miniGames: [],
      payScenes: [],
      pcScenes: SITESET_PCQQ_SCENES,
      qbSearchScenes: SITESET_QBSEARCH_SCENES,
      wechatSearchScenes: SITESET_WECHAT_SEARCH_SCENES,
      SEARCH_AD_SITE_ENUM,
      AD_MARKETING_SCENE
    }
  },
  created() {
    this.getPageData()
  },
  computed: {
    adAccounts() {
      return this.projectInstance.adAccounts
    },

    planForm: {
      get() {
        return this.value
      },
      set(form) {
        this.$emit('input', form)
      }
    },
    pageStates() {
      return this.projectInstance.pageStates
    },

    showWechatChannels() {
      const { siteSet, automatic_site_enabled } = this.planForm
      return siteSet.includes(SITE_ENUM.CHANNELS) || automatic_site_enabled
    },

    /**
     * @description: 优量汇流量包屏蔽model更新
     */
    excludesUnionPositionPackages: {
      get() {
        const selected = this.planForm.scene_spec.exclude_union_position_package[this.currUnionPackageAccountId]
        return selected || []
      },
      set(vals) {
        const newPlanForm = { ...this.planForm }
        newPlanForm.scene_spec.exclude_union_position_package[this.currUnionPackageAccountId] = vals
        this.planForm = newPlanForm
      }
    },
    showPaySceneTips() {
      // 1024793 对应微信广告位置微信支付订单详情页 的id
      const wechatPostion = this.planForm.wechatPostion
      return wechatPostion.length && !wechatPostion.includes(1024793)
    },
    /* 显示场景提示 */
    showMiniGameTips() {
      // [1024794, 1024795, 1024796, 1024797] 对应微信广告位置 小程序banner | 广告小程序激励式广告 | 小程序插屏广告 |  小程序封面广告 的id
      const wechatPostion = this.planForm.wechatPostion
      return wechatPostion.length && !wechatPostion.some((w) => [1024794, 1024795, 1024796, 1024797].includes(w))
    },
    adAccountsStr() {
      return this.planForm.accounts.join(',')
    }
  },
  watch: {
    adAccountsStr() {
      this.onProjectEdit()
    }
  },
  methods: {
    /**
     * @description: 优量汇流量包屏蔽切换账号时，请求对应账号的数据
     */
    onAccountItemChange(account) {
      this.currUnionPackageAccountId = account.id
      this.getUnionPackages()
    },

    /**
     * @description: 批量新建创意点上一步回来编辑项目的时候 isEdit
     * @description: 批量修改项目的时候 isModify
     * @description: 批量复制项目的时候 isDuplicate
     * @description: 如果优量汇流量包屏蔽是自定义状态时根据账号请求数据回显已选
     */
    async onProjectEdit() {
      await this.$nextTick()
      const flag = this.planForm.excludeUnionType
      if (this.pageStates.isEdit || this.pageStates.isModify || this.pageStates.isDuplicate) {
        this.onExcludeUnionPackageTypeChange(flag)
      }
    },

    getUnionPackages() {
      this.excludePackageLoading = true
      getUnionPositionPackages({ ad_account_id: this.currUnionPackageAccountId, type: 'UNION_PACKAGE_TYPE_EXCLUDE' })
        .then((data) => {
          if (data && data?.length) {
            this.unionPositionPackages = data.map((p) => ({
              id: p.union_package_id,
              value: p.union_package_name
            }))

            console.log('this.unionPositionPackages output: ', this.unionPositionPackages)
          }
          this.excludePackageLoading = false
        })
        .catch(() => {
          this.excludePackageLoading = false
        })
    },
    /**
     * @description: 切换到自定义时，请求第一个账号的数据
     * @param {*} val
     */
    onExcludeUnionPackageTypeChange(val) {
      if (val === 1) {
        const [account] = this.adAccounts

        this.currUnionPackageAccountId = account.id
        this.getUnionPackages()
      }
    },

    /**
     * @description: 切换版位时，还原场景定向的设置
     * @param {*} sites
     * @return {*}
     */
    onSiteSetItemChange(sites) {
      // 广播手动版位发生了变化
      this.$bus.$emit('sitesetChange')

      if (!sites.includes(SITE_ENUM.MOBILE_UNION)) {
        this.planForm = {
          ...this.planForm,
          // 优量汇广告展示场景切换到不限，关闭流量优选
          excludeUnionType: 0,
          flow_optimization_enabled: false,
          displaySceneType: 0
        }
      }

      if (!sites.includes(SITE_ENUM.WECHAT)) {
        this.planForm = {
          ...this.planForm,
          // 微信公众号与小程序定投、场景切换到不限
          wechat_position: 0,
          wechat_scene: 0,
          wechatPostion: []
        }
      }
    },

    /**
     * @description: 切换版位类型
     * @param {*} e
     */
    onSiteSetTypeChange(e) {
      // 广播自动版位发生了切换
      this.$bus.$emit('automaticSiteEnabledChange')
      // 切换时,默认全选
      this.planForm = {
        ...this.planForm,

        // 自动版位时，使用默认值
        siteSet: e ? DEFAULT_SITES : getAllSiteSet()
      }
    },
    onOfficialAccountMediaCateChange(v) {
      this.toggleWechatSceneCheckStates(v, 1, 'officialAccountMediaCate')
    },
    onMiniGameChange(v) {
      this.toggleWechatSceneCheckStates(v, 1001000, 'miniGame')
    },
    onPaySceneChange(v) {
      this.toggleWechatSceneCheckStates(v, 3000000, 'payScene')
    },
    toggleWechatSceneCheckStates(v, needle, prop) {
      const [firstLabel] = v
      const newForm = this.planForm
      // 不限的label = needle， 每组不限的id都不一致
      // v.length > 1 防止没有任何勾选时，点击不限选不上
      if (firstLabel === needle && v.length > 1) {
        newForm[prop] = v.filter((v) => v !== needle)
      } else {
        if (v.includes(needle)) {
          newForm[prop] = [needle]
        }
      }

      this.planForm = newForm
    },
    getPageData() {
      // 获取场景定向标签 https://developers.e.qq.com/docs/api/tools/scene_spec_tags/scene_spec_tags_get?version=1.3
      Promise.all([
        getWechatPositions({ ad_account_id: 5165, type: 'WECHAT_POSITION' }),
        getWechatPositions({ ad_account_id: 5165, type: 'OFFICIAL_ACCOUNT_MEDIA_CATEGORY' }),
        getWechatPositions({ ad_account_id: 5165, type: 'MINI_PROGRAM_AND_MINI_GAME' }),
        getWechatPositions({ ad_account_id: 5165, type: 'PAY_SCENE' }),
        getWechatPositions({ ad_account_id: 5165, type: 'WECHAT_CHANNELS_SCENE' })
      ]).then((data) => {
        const [wechatPositions, officialAccountMediaCates, miniGames, payScenes, wechatChannelPositions] = data
        if (wechatPositions?.list && isArray(wechatPositions.list)) {
          this.wechatPositions = wechatPositions.list
        }

        if (wechatChannelPositions?.list && isArray(wechatChannelPositions.list)) {
          // 20250217 tg4.49 过滤掉【2100489-视频号评论区广告】
          const list = wechatChannelPositions.list.filter((i) => ![2100489].includes(i.id))
          this.wechatChannelPositions = list
        }

        if (officialAccountMediaCates?.list && isArray(officialAccountMediaCates.list)) {
          this.officialAccountMediaCates = officialAccountMediaCates.list
        }

        if (miniGames?.list && isArray(miniGames.list)) {
          this.miniGames = miniGames.list
        }

        if (payScenes?.list && isArray(payScenes.list)) {
          this.payScenes = payScenes.list
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.wechat-scene-spec {
  margin-top: 15px;
  .wechat-scenes-row {
    margin-bottom: 15px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
}

.exclude-union-selector {
  display: flex;
  .accounts {
    min-width: 220px;
    border: 1px solid #dee4f5;
    border-radius: 4px;
    border-right: none;
    .header {
      background: #fafbfe;
      padding: 0 10px;
      border-bottom: 1px solid #dee4f5;
    }

    .row-list {
      height: 163px;
      overflow: auto;
      .row-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        cursor: pointer;
        font-size: 12px;
        margin-bottom: 0;

        > span {
          display: block;
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:hover,
        &.active {
          background: #eee;
        }
      }
    }
  }

  .selector-box {
    flex: 1;
  }
}
</style>
